import {
    DASHBOARD_PUBLIC_QUICK_ACTIONS_ERROR,
    DASHBOARD_PUBLIC_QUICK_ACTIONS_REQUEST,
    DASHBOARD_PUBLIC_QUICK_ACTIONS_SUCCESS,
  } from "../../Types/user/Types";
  
  const initialState = {
    error: "",
    dashboard_public_quick_actions_data:"",
    loader: false,
  };
  const Dashboard_Public_Quick_Actions_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case DASHBOARD_PUBLIC_QUICK_ACTIONS_SUCCESS:
        return {
          ...initialState.dashboard_public_quick_actions_data,
          error: "",
          dashboard_public_quick_actions_data: action.payload,
          loader: false,
        };
      case DASHBOARD_PUBLIC_QUICK_ACTIONS_ERROR:
        return {
          ...initialState.dashboard_public_quick_actions_data,
          error: action.error,
          dashboard_public_quick_actions_data: "",
          loader: false,
        };
      case DASHBOARD_PUBLIC_QUICK_ACTIONS_REQUEST:
        return {
          ...initialState.dashboard_public_quick_actions_data,
          error: null,
          dashboard_public_quick_actions_data: "",
          loader: true,
        };
      default:
        return state;
    }
  };
  
  export default Dashboard_Public_Quick_Actions_Reducer;
  